export const containerConfig = {
  // Note: do not use singletons, use appContainer.registerSingleton or appContainer.resolveOnce to
  // enable code-splitting
  singletons: [],
};
